import { styled } from '@mui/system'
import { Img } from '../Image/Img'

type ProfileImageProps = {
  img: string
  alt?: string
}

export const ProfImg = styled(Img)(({ theme }) => ({
    width: 100,
    margin: theme.spacing(1),
    borderRadius: '50%',
    [theme.breakpoints.between('sm', 'md')]: {
      width: 80,
    },
    [theme.breakpoints.down('sm')]: {
      width: 60,
    },
}))

export const ProfileImage: React.FC<React.PropsWithChildren<ProfileImageProps>> = ({
  img,
  alt = '',
}) => {
  return <ProfImg src={img} alt={`${alt}`} />
}
